import React, { useEffect, useState } from 'react'
import { CssBaseline } from '@material-ui/core'

import { getPlacesData, updateGeoHashes, getGooglePlacePhoto, getGooglePlaceDataByID, writeReview, getAddressFromCoordinates, likeQuestionAtLocation, dislikeQuestionAtLocation } from './api'
import Header from './components/Header/Header'
import Map from './components/Map/Map'
import InitialCategoryDialog from './components/SimpleDialogue/InitialCategoryDialog'
import ReviewsModal from './components/Modals/ReviewsModal'
import WriteReviewModal from './components/Modals/WriteReviewModal'
import AlertModal from './components/Modals/AlertModal'
import MobilePlaceModal from './components/Modals/MobilePlaceModal'
import AddCustomLocationModal from './components/Modals/AddCustomLocationModal'
import LoadingModal from './components/Modals/LoadingModal'

const App = () => {

    const [open, setOpen] = useState(false)

    const [places, setPlaces] = useState([])
    const [filteredPlaces, setFilteredPlaces] = useState([])

    const [childClicked, setChildClicked] = useState(-1)
    const [mobileChildClickedModalOpen, setMobileChildClickedModalOpen] = useState(false)

    const [coordinates, setCoordinates] = useState({})
    const [mapSize, setMapSize] = useState({})
    const [zoom, setZoom] = useState(14)

    const [isLoading, setIsLoading] = useState(false)
    const [type, setType] = useState('View All')

    const [map, setMap] = useState(null)
    const [maps, setMaps] = useState(null)

    const [placeData, setPlaceData] = useState(null)
    const [placeDataImageURL, setPlaceDataImageURL] = useState('')

    const [reviewData, setReviewData] = useState(null)
    const [reviewDataModalOpen, setReviewDataModalOpen] = useState(false)
    
    const [writeReviewData, setWriteReviewData] = useState({})
    const [writeReviewModalOpen, setWriteReviewModalOpen] = useState(false)

    const [addingCustomLocation, setAddingCustomLocation] = useState(false)
    const [customLocationCoordinates, setCustomLocationCoordinates] = useState({})
    const [reverseGeocodingAddress, setReverseGeocodingAddress] = useState({})
    const [addCustomLocationModalOpen, setAddCustomLocationModalOpen] = useState(false)

    const [alertModalOpen, setAlertModalOpen] = useState(false)

    function componentDidMount() {
        setLikes(JSON.parse(localStorage.likes))
        setDislikes(JSON.parse(localStorage.dislikes))
    }

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(({ coords: {latitude, longitude} }) => {
            const newCoords = {lat: latitude, lng: longitude}
            setCoordinates(newCoords)
            setChildClicked(-1)
            setFilteredPlaces([])
            getPlacesData(newCoords, zoom, setPlaces, setIsLoading)
            setOpen(true)
        })
    }, [])

    useEffect(() => {
        if(reviewData) {
            setReviewDataModalOpen(true)
        }
    }, [reviewData])

    useEffect(() => {
        if(writeReviewData?.name) {
            setWriteReviewModalOpen(true)
        }
    }, [writeReviewData])

    useEffect(() => {
        if(writeReviewModalOpen == false) {
            setWriteReviewData({})
        }
    }, [writeReviewModalOpen])

    useEffect(() => {
        if(childClicked >= 0) {
            if(filteredPlaces[childClicked]?.googleID && filteredPlaces[childClicked].googleID != "") {
                getGooglePlaceDataByID(map, maps, filteredPlaces[childClicked].googleID, setPlaceData)
            }
            else {
                const targetPlace = filteredPlaces[childClicked]
                const data = {
                    name: targetPlace.name,
                    formatted_address: targetPlace.address + " " + targetPlace.city + ", " + targetPlace.state + " " + targetPlace.zipcode,
                }
                if(targetPlace?.phone) {
                    data.formatted_phone_number = targetPlace.phone
                }
                if(targetPlace?.website) {
                    data.website = targetPlace.website
                }
                setPlaceData(data)
            }
        }
    }, [childClicked])

    useEffect(() => {
        if(addingCustomLocation) {
            //getAddressFromCoordinates(customLocationCoordinates.lat, customLocationCoordinates.lng, maps, setReverseGeocodingAddress)
            setAddCustomLocationModalOpen(true)
        }
    }, [customLocationCoordinates])

    useEffect(() => {
        setPlaceDataImageURL('')
        if(placeData?.name) {
            setMobileChildClickedModalOpen(true)
            if(placeData?.photos) {
                getGooglePlacePhoto(placeData, setPlaceDataImageURL)
            }
        }
        else {
            setMobileChildClickedModalOpen(false)
        }
    }, [placeData])

    // RUN THIS FUNCTION WHEN YOU WANT TO UPDATE GEOHASHING
    /*useEffect(() => {
        console.log('STARTING GEO UPDATE')
        updateGeoHashes()
    }, [])*/

    function updateData() {
        if(mapSize.width && mapSize.height) {
            setChildClicked(-1)
            setFilteredPlaces([])
            getPlacesData(coordinates, zoom, setPlaces, setIsLoading)
        }
    }

    function finishedAddingReview() {
        setIsLoading(false)
        setWriteReviewModalOpen(false)
        setReviewDataModalOpen(false)
        setAlertModalOpen(true)
        updateData()
    }

    function finishedAddingCustomLocation() {
        setIsLoading(false)
        setAddCustomLocationModalOpen(false)
        setAddingCustomLocation(false)
        updateData()
    }

    useEffect(() => {
        //const filtered1 = places.filter((place) => (place.category1.incudes(type)))
        //const filtered2 = places.filter((place) => (place.category2.includes(type)))
        const filtered1 = places.filter((place) => (place.category1 === type))
        const filtered2 = places.filter((place) => (place.category2 === type))
        var filtered = filtered1.concat(filtered2)

        if(type == "View All") {
            filtered = places
        }

        // If we're adding a custom place then we don't want any markers displayed.
        if(addingCustomLocation) {
            setFilteredPlaces([])
        }
        else{
            setFilteredPlaces(filtered)
        }
    }, [type, places, addingCustomLocation])

    // Likes/Dislikes stuff
    const [likes, setLikes] = useState(() => {
        return JSON.parse(localStorage.getItem('likes')) || []
    })
    const [dislikes, setDislikes] = useState(() => {
        return JSON.parse(localStorage.getItem('dislikes')) || []
    })
    function likeNodeQuestion(nodeID, isLiked) {
        if(isLiked) {
            setLikes([...likes, nodeID])
        }
        else {
            setLikes(likes.filter(item => item !== nodeID))
        }
        likeQuestionAtLocation(nodeID, isLiked)
    }
    function dislikeNodeQuestion(nodeID, isDisliked) {
        if(isDisliked) {
            setDislikes([...dislikes, nodeID])
        }
        else {
            setDislikes(dislikes.filter(item => item !== nodeID))
        }
        dislikeQuestionAtLocation(nodeID, isDisliked)
    }
    useEffect(() => {
        console.log('updating likes')
        window.localStorage.setItem("likes", JSON.stringify(likes))
    }, [likes])
    useEffect(() => {
        console.log('updating dislikes')
        window.localStorage.setItem("dislikes", JSON.stringify(dislikes))
    }, [dislikes])
    // End likes/dislikes stuff

    const handleInitialTypeSelectionClose = (value) => {
        setOpen(false);
        setType(value);
    };

    function renderMobileMap() {
        return (
            <>
                <CssBaseline />
                <Header type={type} setType={setType} addingCustomLocation={addingCustomLocation} setAddingCustomLocation={setAddingCustomLocation} />
                <Map
                    type={type}
                    setType={setType}
                    setCoordinates={setCoordinates}
                    setZoom={setZoom}
                    setMapSize={setMapSize}
                    updateData={updateData}
                    coordinates={coordinates}
                    places={filteredPlaces}
                    setChildClicked={setChildClicked}
                    childClicked={childClicked}
                    category={type}
                    setMap={setMap}
                    setMaps={setMaps}
                    addingCustomLocation={addingCustomLocation}
                    setCustomLocationCoordinates={setCustomLocationCoordinates}
                />
                <InitialCategoryDialog
                    selectedValue={type}
                    open={open}
                    onClose={handleInitialTypeSelectionClose}
                />
                <MobilePlaceModal open={mobileChildClickedModalOpen} place={filteredPlaces[childClicked]} placeDetails={placeData} placeDataImageURL={placeDataImageURL} setReviewData={setReviewData} setWriteReviewData={setWriteReviewData} setModalOpen={setMobileChildClickedModalOpen} setChildClicked={setChildClicked} likes={likes} likeQuestion={likeNodeQuestion} dislikes={dislikes} dislikeQuestion={dislikeNodeQuestion} />
                <ReviewsModal place={filteredPlaces[childClicked]} reviews={reviewData} open={reviewDataModalOpen} setModalOpen={setReviewDataModalOpen} setWriteReviewData={setWriteReviewData} />
                <WriteReviewModal place={writeReviewData} open={writeReviewModalOpen} setModalOpen={setWriteReviewModalOpen} submitReview={writeReview} finishedAddingReview={finishedAddingReview} setIsLoading={setIsLoading}/>
                <AddCustomLocationModal open={addCustomLocationModalOpen} setModalOpen={setAddCustomLocationModalOpen} isLoading={isLoading} setIsLoading={setIsLoading} customLocationCoordinates={customLocationCoordinates} finishedAddingCustomLocation={finishedAddingCustomLocation} />
                <AlertModal open={alertModalOpen} setModalOpen={setAlertModalOpen} title="Success!" description="Thanks for leaving a review!" />
                <LoadingModal open={isLoading} />
            </>
        )
    }

    return (
        renderMobileMap()
    )
}

export default App